//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "score-approval",
  props: ['dataId'],
  data() {
    return {
      selectModel: 'base',
      scorePlanDto: {},
      scorePlanId: null,
      scoreStatus:[
        {label:'未评分',code:null},
        {label:'未评分',code:'NOT_STARTED'},
        {label:'评分中',code:'ONGOING'},
        {label:'已评分',code:'FINISH'},
        {label:'预期未评分',code:'NOT_SCORING'},
        {label:'已禁止评分',code:'DISABLED'},
      ],
    }
  },
  methods: {
    valid(){
      return true;
    },
    formData(){
      return this.scorePlanDto;
    },
    changeShowModel(str) {
      this.selectModel = str;
      if (str !== 'flow') {
        this.$emit('changeFlowInfo', false);
      } else {
        this.$emit('changeFlowInfo', true);
      }
    },
    changeShow(data){
      if(data.cellShow){
        this.$set(data,'cellShow',false);
        return;
      }
      this.$set(data,'cellShow',true);
    },
    changeSelected(data,str){
      this.$set(data,'showInfoType',str);
    },
    getScoreData() {
      this.$loadingShow();
      this.$get(`api/sourceRating/${this.scorePlanId}`).then((res) => {
        if (res) {
          this.scorePlanDto = res;
        }
        this.$loadingHide();
      }).catch(() => {
        this.$loadingHide();
      })
    },
    showRuleList(item) {
      let str = '';
      if (item.length) {
        item.forEach(val => {
          str += val + '<br/>';
        })
      }
      if (!str) {
        str = '暂无数据'
      }
      this.$vux.toast.text(str, 'middle')
    }
  },
  mounted() {
    this.scorePlanId = this.dataId;
    this.getScoreData();
  }
}



// WEBPACK FOOTER //
// ./src/page/sources/source-score/score-approval.vue